export enum ConfirmationResult {
    Confirmed,
    Declined
}
